import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { qimoArr, mujuArr, biaomianArr, jixieArr, dengjuArr, diandongArr, tongxunArr } from "../../data/products";

@Component({
  selector: 'app-product',
  templateUrl: './product.component.html',
  styleUrls: ['./product.component.scss', './product.component.media.scss']
})
export class ProductComponent implements OnInit {
  qualityArr = [
    {
      title: '技术',
      src: './assets/zhijian-2.jpg',
      content: '公司引进具有世界先进水平的模具制造加工及检测设备近百台，致力于向客户提供更先进、更合理、更精密的优质模具。'
    },
    {
      title: '专业',
      src: './assets/zhijian-3.jpg',
      content: '所有操机人员都需要经培训合格后才能上岗，并定期进行复训，将最新的加工技术融入到实践中。'
    },
    {
      title: '检测',
      src: './assets/zhijian-4.jpg',
      content: '模具通过5轴高速加工中心、EDM、W-EDM等先进的加工设备完成，所有工序都需要自检和专检，保证加工一次到位。'
    }
  ];
  bottomArr = [
    {
      title: '获得知识产权',
      content: '55项'
    },
    {
      title: '获得发明专利',
      content: '18项'
    },
    {
      title: '获得实用专利',
      content: '36项'
    }
  ];
  productList = [
    {
      label: 'Auto Parts',
      path: 'product',
      active: true,
      src: qimoArr
    },
    {
      label: 'Communication',
      path: 'product',
      active: false,
      src: tongxunArr
    },
    {
      label: 'Electric Power',
      path: 'product',
      active: false,
      src: diandongArr
    },
    {
      label: 'Lamp',
      path: 'product',
      active: false,
      src: dengjuArr
    },
    {
      label: 'Precision',
      path: 'product',
      active: false,
      src: jixieArr
    },
    {
      label: 'Surface',
      path: 'product',
      active: false,
      src: biaomianArr
    },
    {
      label: 'Mould',
      path: 'product',
      active: false,
      src: mujuArr
    }
  ];
  ind = 0;
  imgInd = 0;
  constructor(
    private route: ActivatedRoute,
    private router: Router
  ) { }

  ngOnInit() {
    const { ind, imgInd } = this.route.snapshot.queryParams;
    console.log(ind, imgInd);
    this.ind = +ind || 0;
    this.imgInd = +imgInd || 0;
  }
  handleChangeProduct(i) {
    this.ind = i;
    this.imgInd = 0;
  }
}
